import React from 'react';
interface SectionCardProps {
  id: string;
  title: string;
  description?: string;
  /** Stretch the card and its body to fill the available column height. */
  fill?: boolean;
  children: React.ReactNode;
}
export function SectionCard({
  id,
  title,
  description,
  fill = false,
  children
}: SectionCardProps) {
  return <section id={id} aria-labelledby={`${id}-heading`} className={`scroll-mt-6 overflow-hidden rounded-lg border border-slate-200 bg-white shadow-sm ${fill ? 'flex h-full flex-col' : ''}`} data-id="element-62" data-mp="1d4mam1613eav">
      <header className="border-b border-slate-200 bg-slate-50 px-4 py-2.5" data-id="element-63" data-mp="le7ya9dnya1b">
        <h2 id={`${id}-heading`} className="text-sm font-bold text-slate-900 underline decoration-slate-300 decoration-1 underline-offset-4" data-id="element-64" data-mp="z4juokha6uy9">
          {title}
        </h2>
        {description && <p className="mt-0.5 text-xs text-slate-500" data-id="element-65" data-mp="6lo3bw0o38uy">{description}</p>}
      </header>
      <div className={`space-y-5 px-4 py-4 ${fill ? 'flex-1' : ''}`} data-id="element-66" data-mp="1nuvkyjpu6sk">{children}</div>
    </section>;
}